import { AddAgendaItemPositionEnum, getAddAgendaItemPositionLabel } from "enums/AddAgendaItemPositionEnum";
import { NumberChoiceModel } from "models/ChoiceModel";
import { TranslationsContextProps } from "providers";

export function getAddAgendaItemPositions(i18n: TranslationsContextProps): NumberChoiceModel[] {
  return [AddAgendaItemPositionEnum.Last, AddAgendaItemPositionEnum.AfterSelected].map((x) => ({
    name: AddAgendaItemPositionEnum[x],
    text: getAddAgendaItemPositionLabel(x, i18n),
    value: x,
    disabled: false,
  }));
}
